export const FETCH_ARTISTS = 'FETCH_ARTISTS';
export const CLEAR_ARTISTS = 'CLEAR_ARTISTS';
